import { Injectable } from '@angular/core';
import { CultureMapItemModel } from '../entities/culture-map-item.model';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { CultureMapFilterKey } from '../enums/culture-map-filter-key';

@Injectable({ providedIn: 'root' })
export class CultureMapMapDataService extends InjectableMapDataStateService<CultureMapItemModel, CultureMapFilterKey> {
}
